import React, {Component} from 'react';

export default class Home extends Component {
    render() {
        return (
            <div>
                <h2>FUNDOVINO, c'est quoi ?</h2>
                <div>
                    <p>
                        Entrepreneurs de la net-économie, les associés qui portent le projet Fundovino ont chacun leur spécialité : gestion, développement, marketing, communication.
                        Mais ensemble, ils ont en commun d'aimer le vin et les idées neuves.
                        C'est pour cette passion qu'ils se sont retrouvés autour du projet Fundovino, premier site de financement participatif dédié au monde du vin.
                    </p>
                    <h3>Le projet Fundovino est unique :</h3>
                    <p>
                        il s'inscrit dans le respect de la vigne mais aussi des hommes qui l'élèvent, la bonifient et la travaillent pour l'offrir aux palais des autres.
                        il participe d'une « éthique de l'étiquette ».
                    </p>
                </div>
            </div>
        );
    }
}
